import type React from "react"
import { useState,useEffect } from "react"
import { toast } from "react-toastify"
import {Link, useNavigate } from "react-router-dom";
import { Lock, CheckCircle } from "lucide-react";
import BuilderService from '../../services/BuilderService';
import { Loader } from './Loader';
import { useTheme } from '../../../redux/hooks/useTheme';
import { motion, Variants } from 'motion/react';
import Logo from '../Dashboard/SubComponents/Logo';



const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState<string>("")
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [canResend, setCanResend] = useState<boolean>(false);
  const [timer, setTimer] = useState<number>(60);
  const [isResending, setIsResending] = useState<boolean>(false);
  const navigate = useNavigate();
  const builderService = new BuilderService();
  const { theme } = useTheme();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      toast.error("Please enter email");
      return;
    }

    try {
      setIsLoading(true);
      const response = await builderService.forgotPassword(email);
      
      if (response.success) {
        setIsSuccess(true);
        toast.success('Reset link sent to your email!');
        // navigate('/login');
      } else {
        toast.error(response.message || 'Failed to send reset link');
      }
    } catch (error) {
      toast.error('Failed to send reset link');
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };
  const handleResend = async () => {
    try {
      setIsResending(true);
      setCanResend(false);
      setTimer(60);
  
      const response = await builderService.forgotPassword(email);
      
      if (response.success) {
        toast.success('Reset link sent again!');
      } else {
        toast.error(response.message || 'Failed to resend reset link');
        setCanResend(true);
      }
    } catch (error) {
      toast.error('Failed to resend reset link');
      setCanResend(true);
    } finally {
      setIsResending(false);
    }
  };
  useEffect(() => {
    let interval: NodeJS.Timeout;
    
    if (isSuccess && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            setCanResend(true);
            return 0;
          }
          return prevTimer - 1;
        });
      }, 1000);
    }
  
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isSuccess, timer]);

  if (isSuccess) {
    return (
      <div 
      style={{
        background: `url(${theme.heroSectionImage}) no-repeat`,
        backgroundColor: theme.heroSectionBackgroundGradient,
        backgroundSize:'cover',
      backgroundPosition:'center',
      backgroundRepeat:'no-repeat'
      }}
      className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
       <div>
       <div className="flex flex-col justify-center items-center gap-[40px] ">
      <header className="pt-[37px]">
      <motion.div
                        className="flex items-center mt-[-150px] w-[132px] sm:w-auto logo-mob"
                      >
                        <Link to="/">
                        {/* <img
                          src={theme.heroLogo} // Use src instead of background
                          className="h-10 mr-2 md:p-0"
                          alt="Advance To Builder"
                        />   */}
                        <Logo />

                        </Link>
                      </motion.div>
      </header>
        <div className="w-full max-w-[538px] overflow-hidden">
          <div className="flex flex-col items-center text-center">
            <div className="w-[78px] h-[93px] rounded-full flex items-center justify-center mb-[24px]">
              <div className="w-[78px] h-[93px] rounded-md flex items-center justify-center relative">
                <div className="w-[78px] h-[93px] rounded-t-md"></div>
                <div className="absolute -top-1 -right-1">
                  <img src="https://dlvkyia8i4zmz.cloudfront.net/tool_builder/1743011411238_Group.png" alt="" />
                </div>
              </div>
            </div>
            <h2 style={{ color: theme.mainHeadingOne, fontWeight:600 }} className="text-[26px]  font-sora">Password Reset Link Sent</h2>
            <p style={{color:theme.SubHeadingSubTwo,fontWeight:400}} className="text-[16px] mt-[10px] font-inter">
              We've sent a reset link to <span className="font-inter" style={{fontWeight:600}}>{email}</span>. Check your inbox and follow the instructions to reset your password.
            </p>
            <button 
            style={{fontWeight:600}}
                  onClick={handleResend}
                  disabled={isResending || !canResend}
              className=" mt-[32px] font-inter sign-upbt py-[14px] px-4 text-white font-medium rounded-[12px] transition-colors"
            >
                {isResending ? (
                <Loader text="Resending..." />
                ) : !canResend ? (
                  `Resend Email (${timer}s)`
                ) : (
                  "Resend Email"
                )}
          </button>
          </div>
        </div>
        </div>
       </div>
      </div>
    );
  }


  return (
    <div style={{
      background: `url(${theme.heroSectionImage}) no-repeat`,
      backgroundColor: theme.heroSectionBackgroundGradient,
      backgroundSize:'cover',
      backgroundPosition:'center',
      backgroundRepeat:'no-repeat'
    }} className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
     <div className="flex flex-col justify-center items-center gap-[50px] ">
     <motion.div
                className="flex items-center w-[132px] mt-[-100px] sm:w-auto logo-mob"
              >
                <Link to="/">
                {/* <img
                  src={theme.heroLogo} // Use src instead of background
                  className="h-10 mr-2 md:p-0"
                  alt="Advance To Builder"
                />   */}
                <Logo />
                </Link>
              </motion.div>
              <div className="sign-up-upr"> 
            <div
  className="w-full max-w-[480px] rounded-[20px] bg-white p-[20px] sm:p-[32px] md:p-8 shadow-sm signup-p"
  style={{ width: '100%' }}
>
        <div className="space-y-6">
          {/* Header */}
          
          <div className="text-center">
            <div className="flex justify-center mb-[24px]">
                <div className="p-3 rounded-xl">
                  <img src="https://dlvkyia8i4zmz.cloudfront.net/tool_builder/1743012654621_Frame__3_.png" alt="" />
                </div>
            </div>
            <h2 style={{ color: theme.mainHeadingOne, fontWeight:600 }} className="text-[22px] mb-[10px] font-sora">Forgot Your Password?</h2>
            <p style={{color:theme.SubHeadingSubTwo,fontWeight:400}} className="text-[16px] mb-[24px] font-inter">No worries! Enter your email to receive a password reset link.</p>
          </div>

          {/* Form */}
          <form className="" onSubmit={handleSubmit}>
            {/* Email Input */}
            <div className="relative mb-[32px]">
              <div className="absolute px-[15px] py-[17px] flex items-center spborder-r">
                <span style={{color:theme.seIcon}}>
                 <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.7499 15.375H5.24994C2.99994 15.375 1.49994 14.25 1.49994 11.625V6.375C1.49994 3.75 2.99994 2.625 5.24994 2.625H12.7499C14.9999 2.625 16.4999 3.75 16.4999 6.375V11.625C16.4999 14.25 14.9999 15.375 12.7499 15.375Z" stroke="currentColor" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.7501 6.75L10.4026 8.625C9.63006 9.24 8.36256 9.24 7.59006 8.625L5.25006 6.75"  stroke="currentColor" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </span>
              </div>
              <input
                type="email"
                placeholder="Enter email"
                className="w-full sp-border signout-h rounded-[12px] border py-[14px] pl-[55px] pr-4  focus:outline-none"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* Send Reset Link Button */}
            <button
            style={{fontWeight:600}}
            type="submit"
            disabled={isLoading}
            className="w-full sign-upbt rounded-[12px] font-inter py-[14px] text-center font-[14px] text-white focus:outline-none disabled:opacity-50"
          >
            {isLoading ? (
              <span className="flex items-center justify-center">
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Sending...
              </span>
            ) : (
              "Send Email"
            )}
          </button>

            {/* Back to Login Link */}
            <div style={{fontWeight:400, textAlign:'center' }} className="s-suggestion mt-[14px] font-inter text-[12px]">
              Remember your password?{" "}
              <button 
                type="button"
                className="hover:underline" 
                onClick={() => navigate('/login')}
              >
                <span className="gradient-text font-inter hover:underline hover:decoration-[#ff3ab6]">Back to Login</span>
              </button>
            </div>
          </form>
        </div>
              </div>
     </div>   
     </div>
       
    </div>
  );
};

export default ForgotPassword;